module.exports = __webpack_public_path__ + "img/problem_lightning.250d7427.svg";